package utils

object Patterns {

    val EMAIL_ADDRESS = Regex("^[A-Za-z0-9+_.%-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$")
}